
export class RegisterRequest {
    Name?: string;
    Surname?: string;
    Country?: string;
    Affiliation?: string;
    NewsletterEnabled?: boolean;
    Nickname?: string;
    Email?: string;
    Password?: string;
  
}



